module.exports = __webpack_public_path__ + "static/media/limited.c9fb96cd.svg";